export default function SystemSection() {
  const products = [
    {
      icon: 'ri-flask-line',
      name: 'CARBS',
      description: 'High-carb endurance fuel using a science-backed 1:0.8 maltodextrin to fructose ratio — the same ratio validated for peak carbohydrate oxidation above 90g per hour. No GI lock-in. No bottle size restrictions. 30g to 120g per bottle, you decide.',
      benefit: 'Up to 120g carbs per bottle',
      color: '#00FF88'
    },
    {
      icon: 'ri-drop-line',
      name: 'ELECTROLYTES',
      description: 'A complete mineral matrix dosed for long-course racing — not a gym session. 800mg sodium citrate, 200mg potassium citrate, 100mg magnesium glycinate, 30mg calcium citrate. Every mineral. Every form chosen for absorption, not cost.',
      benefit: '800mg sodium per serving — Ironman grade',
      color: '#00FF88'
    },
    {
      icon: 'ri-flashlight-line',
      name: 'CAFFEINE + FOCUS',
      description: 'Precision caffeine at 30mg per scoop — dose exactly what you need, bottle by bottle. Paired with L-Theanine at a 2:1 ratio for smooth, sustained focus with zero jitters. No spike. No crash. No surprise at mile 18.',
      benefit: '30mg caffeine + 60mg L-Theanine per scoop',
      color: '#00FF88'
    }
  ];

  const combinations = [
    {
      name: 'Long Endurance Ride',
      icons: ['ri-flask-line', 'ri-drop-line'],
      combo: 'Carbs + Electrolytes — 90g carbs, 1 electrolyte stick. 4-6 hour fuel.'
    },
    {
      name: 'Race Day (Ironman/70.3)',
      icons: ['ri-flask-line', 'ri-drop-line', 'ri-flashlight-line'],
      combo: 'Carbs + Electrolytes + Caffeine — 120g carbs, full electrolyte dose, caffeine loaded for last 2 hours.'
    },
    {
      name: 'Morning Run (under 90 min)',
      icons: ['ri-drop-line', 'ri-flashlight-line'],
      combo: 'Electrolytes + Caffeine — no carbs needed. Sodium, magnesium, and a clean 30mg caffeine hit.'
    }
  ];

  return (
    <section className="bg-[#FAFAFA] py-32 lg:py-44">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <h2 className="text-5xl lg:text-6xl font-bold text-black text-center mb-20 lg:mb-24 leading-tight">
          One System. Infinite Fueling Strategies.
        </h2>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 mb-28">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white border-2 border-black rounded-2xl p-12 lg:p-14 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center mb-10">
                <i className={`${product.icon} text-[80px] leading-none`} style={{ color: product.color, strokeWidth: '3px' }}></i>
              </div>

              {/* Product Name */}
              <h3 className="text-3xl font-bold text-black mb-5 uppercase tracking-tight">
                {product.name}
              </h3>

              {/* Description */}
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                {product.description}
              </p>

              {/* Key Benefit */}
              <p className="text-base font-bold" style={{ color: product.color }}>
                {product.benefit}
              </p>
            </div>
          ))}
        </div>

        {/* Combination Examples */}
        <div className="text-center mb-14">
          <h3 className="text-3xl font-bold text-black mb-4">
            Build Your Bottle. Every Workout Is Different.
          </h3>
          <p className="text-lg text-gray-600">
            Stop forcing a fixed formula onto a variable effort.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {combinations.map((combo, index) => (
            <div
              key={index}
              className="bg-gray-100 rounded-xl p-8 text-center hover:bg-gray-200 transition-colors cursor-pointer"
            >
              {/* Icons */}
              <div className="flex items-center justify-center gap-3 mb-6">
                {combo.icons.map((icon, iconIndex) => (
                  <div key={iconIndex} className="flex items-center">
                    <div className="w-10 h-10 flex items-center justify-center">
                      <i className={`${icon} text-[40px] text-[#00FF88] leading-none`}></i>
                    </div>
                    {iconIndex < combo.icons.length - 1 && (
                      <span className="text-2xl text-gray-400 mx-2">+</span>
                    )}
                  </div>
                ))}
              </div>

              {/* Workout Type */}
              <p className="text-lg font-bold text-black mb-2">
                {combo.name}
              </p>

              {/* Combination */}
              <p className="text-sm text-gray-600 font-medium">
                {combo.combo}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}